import { JSX } from "react";

interface EPDContainerProps {
  readonly children: React.ReactNode;
  readonly ref: React.Ref<HTMLDivElement>;
}

export function EPDContainer({ children, ref }: EPDContainerProps): JSX.Element {
  return (
    <div ref={ref} className="absolute inset-0 flex flex-col overflow-hidden">
      {children}
    </div>
  );
}
